import React from "react";

import { FaqCategoryItem } from "../../types";
import styles from "../FaqCategoryItems.module.scss";

const teacherLoginUrl = `${process.env.REACT_APP_TEACHER_DLP_URL}/te/login`;
const studentLoginUrl = `${process.env.REACT_APP_STUDENT_DLP_URL}/st/login`;
const managerUrl = process.env.REACT_APP_MANAGER_URL ?? "";

const Answer = () => (
  <div className={styles.answer}>
    <div className={styles.head}>
      <span className={styles.icon}>A</span>
      <p className={styles.text}>以下のURLよりログインすることができます。</p>
    </div>
    <div>
      <p className={styles.heading}>【先生画面】</p>
      <a className={styles.link} href={teacherLoginUrl}>
        {teacherLoginUrl}
      </a>
    </div>
    <div>
      <p className={styles.heading}>【生徒画面】</p>
      <a
        className={styles.link}
        href={studentLoginUrl}
        target="_blank"
        rel="noopener noreferrer"
      >
        {studentLoginUrl}
      </a>
    </div>
    <div>
      <p className={styles.heading}>【管理画面】※学校管理者の権限が必要です</p>
      <a
        className={styles.link}
        href={managerUrl}
        target="_blank"
        rel="noopener noreferrer"
      >
        {managerUrl}
      </a>
    </div>
  </div>
);

export const LOGIN_LOCATION_FAQ: FaqCategoryItem = {
  id: "login-location-faq",
  question: "どこからログインすればいいかわからない（先生／生徒）",
  Answer,
};
